module.exports = __webpack_public_path__ + "static/media/daog.af31146b.png";